"use client";

import type { CDescriptivePageContent } from "@/lib/api/cms-catalog";
import { useT } from "@/lib/i18n/context";
import { ParagraphRenderer } from "@/components/cms/Paragraphs/ParagraphRenderer";
import { cDedicatedDescriptivePageTranslations } from "./CDedicatedDescriptivePage.i18n";
import styles from "./CDedicatedDescriptivePage.module.css";

export function CDedicatedDescriptivePage({ content }: CDedicatedDescriptivePageProps) {
  const t = useT(cDedicatedDescriptivePageTranslations);

  if (!content || typeof content !== "object") {
    return <div className={styles.empty}>{t.emptyData}</div>;
  }

  return (
    <ParagraphRenderer
      paragraphs={Array.isArray(content.paragraphs) ? content.paragraphs : []}
      emptyMessage={t.emptyContent}
    />
  );
}

export type CDedicatedDescriptivePageProps = {
  content: CDescriptivePageContent;
};
